import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import configs from '../../../configs/configuration';
import { recentAddressSlice } from '../store';

export default function useDeliveryMethod() {
  const dispatch = useDispatch();
  const recentAddress = useSelector((state) => state.recentAddress);

  const isSameDay = (date) => {
    if (!date) return false;
    return moment().format('YYYY-MM-DD') === date;
  };

  const getDeliveryMethod = (delivery, date) => {
    if (!delivery.deliveryMethod) return '';
    if (!date || configs.siteCode === 'MY') return delivery.deliveryMethod;
    if (delivery.deliveryType !== 'SFL') return delivery.deliveryMethod;
    let currentMethod = delivery.deliveryMethod;
    if (delivery.deliveryMethod.length > 2) {
      currentMethod = delivery.deliveryMethod.slice(0, 2);
    }
    return isSameDay(date) ? `${currentMethod}SD` : `${currentMethod}ND`;
  };

  return {
    recentAddress,
    getDeliveryMethod,
    saveRecentAddress: (data) => {
      localStorage.setItem('recentAddress', JSON.stringify(data));
      dispatch(recentAddressSlice.actions.update(data));
    },
    getRecentAddress: () => {
      const data = JSON.parse(localStorage.getItem('recentAddress'));
      dispatch(recentAddressSlice.actions.update(data));
    },
  };
}
